import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { getNextPartId } from "../../../../misc/tools";
import { BaseGeneralConfig, GameBaseScenario, GeneralPartConfig } from "../../../GameBaseScenario";
import WcWorkStoppageComponentsStep1Part1 from "./wc-work-stoppage-components-step1-parts/wc-work-stoppage-components-step1-part1";

export default class WcWorkStoppageComponentsStep1Component {
	private _parts: BaseScenarioPart<GameBaseScenario>[] = [];
	private _partId1 = getNextPartId();
	public get parts() {
		return this._parts;
	}
	constructor(public config: WcWorkStoppageComponentsStep1ComponentMainConfig) {
		let context = this;
		context._parts.push(new WcWorkStoppageComponentsStep1Part1(context.config.scenario, () => {
			config.onDone();
		}, context._partId1, config));
	}

	public start() {
		this.goToPart1();
	}

	goToPart1() {
		this.config.scenario.loadPart(this._partId1);
	}
}

export interface WcWorkStoppageComponentsStep1ComponentMainConfig extends BaseGeneralConfig {
	scenario: GameBaseScenario;
	part1Config?: WcWorkStoppageComponentsStep1ComponentPart1Config;
	onDone: () => void;
}

export interface WcWorkStoppageComponentsStep1ComponentPart1Config extends GeneralPartConfig {
	chapter: () => string;
}